import { render } from "./AppUploadFrame.vue?vue&type=template&id=57d141c2"
import script from "./AppUploadFrame.vue?vue&type=script&lang=js"
export * from "./AppUploadFrame.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__